{
  "Certificates": {
    "title": "Certificados",
    "backToHome": "Página Inicial",
    "loadMore": "Carregar mais",
    "card": {
      "completedAt": "Concluído em {{date}}",
      "download": "Baixar certificado",
      "fallbackTitle": "Certificado"
    },
    "emptyState": {
      "title": "Você ainda não tem certificados",
      "description": "Conclua seus cursos para receber seus certificados aqui."
    },
    "toast": {
      "error": {
        "title": "Ops!",
        "message": "Não foi possível carregar seus certificados. Tente novamente."
      }
    }
  },
  "Orders": {
    "title": "Meus pedidos",
    "details": "Detalhes",
    "columns": {
      "date": "Data",
      "total": "Total"
    },
    "empty": {
      "title": "Você ainda não tem pedidos",
      "description": "Quando você fizer uma compra, seus pedidos aparecerão aqui."
    },
    "orderBump": "Order bump",
    "itemRefunded": "Estornado",
    "itemRefundProcessing": "Estorno em análise"
  },
  "OrderDetails": {
    "title": "Detalhes do pedido",
    "orderId": "NÚMERO",
    "createdAt": "Data do pedido",
    "amount": "Total",
    "amountPaid": "Total pago",
    "orderBumpTitle": "Produtos adquiridos junto:",
    "loadPrintTitle": "Por favor, aguarde",
    "loadPrintDescription": "Isso pode levar alguns segundos.",
    "subscription": {
      "title": "Assinatura",
      "amount": "Valor da assinatura",
      "trial": "Período de teste grátis até",
      "bill": "Próxima cobrança",
      "cancel": "Cancelar assinatura",
      "cancelModal": {
        "title": "Cancelamento de assinatura",
        "description": "Você tem certeza que deseja cancelar a assinatura do produto {{courseName}}",
        "cta": "Cancelar assinatura",
        "stay": "Manter assinatura"
      },
      "downsellModal": {
        "oneShotBadge": "Oferta única",
        "title": "Continue com {{percent}}% de desconto",
        "titleHalf": "Continue por metade do preço",
        "description": "Você mantém tudo o que já tem em <bold>{{courseName}}</bold>. Só o valor muda.",
        "todayLabel": "Hoje",
        "newAmountLabel": "Novo valor",
        "startsAt": "Vale a partir da próxima cobrança, em <bold>{{date}}</bold>. Nada é cobrado agora.",
        "sameAccess": "Mesmo conteúdo, mesmo acesso. Você pode cancelar quando quiser.",
        "accept": "Continuar por {{amount}}",
        "decline": "Não, quero cancelar a assinatura",
        "oneShot": "Esta oferta aparece uma única vez. Se você cancelar, ela não estará mais disponível.",
        "accepted": {
          "title": "Pronto, sua assinatura continua",
          "description": "O desconto foi aplicado a <bold>{{courseName}}</bold>. Seu acesso segue igual, sem interrupção.",
          "newAmountLabel": "Novo valor",
          "nextChargeLabel": "Próxima cobrança",
          "paymentMethodLabel": "Forma de pagamento",
          "note": "Você pode conferir tudo em Detalhes do pedido.",
          "cta": "Voltar para o pedido"
        },
        "error": {
          "description": "Não conseguimos aplicar a oferta. Sua assinatura não foi alterada nem cancelada.",
          "retry": "Tentar novamente"
        }
      },
      "toast": {
        "title": "Lamentamos, mas algo deu errado",
        "description": "Não foi possível cancelar sua assinatura neste momento, por favor, aguarde alguns minutos e tente novamente"
      },
      "unubscribeSuccess": {
        "title": "Cancelamento realizado",
        "description": "Você cancelou a assinatura do produto {{courseName}}. Seu acesso será mantido até {{expirationDate}}"
      },
      "changeCreditCard": {
        "title": "Dados do cartão",
        "ccNumber": "Número do cartão",
        "ccHolder": "Nome impresso no cartão",
        "ccHolderPlaceholder": "EX: João A. Silva",
        "ccExpiration": "Validade",
        "ccExpirationPlaceholder": "MM/AA",
        "ccCvv": "Cód. de segurança",
        "ccCvvPlaceholder_3": "EX: 777",
        "ccCvvPlaceholder_4": "EX: 7777",
        "cta": "Salvar novo cartão",
        "tooltip": "3 dígitos no verso do cartão. Amex: 4 dígitos na frente.",
        "toast": {
          "error": {
            "title": "Algo deu errado!",
            "description": "Verifique os dados informados e tente novamente"
          },
          "success": {
            "title": "Tudo certo!",
            "description": "Cartão alterado com sucesso"
          }
        },
        "validations": {
          "ccNumber": {
            "required": "O número do cartão é obrigatório",
            "invalid": "Número do cartão inválido"
          },
          "ccHolder": {
            "required": "Nome do titular é obrigatório"
          },
          "ccExpiration": {
            "required": "Data de validade é obrigatória",
            "expired": "Data de validade inválida"
          },
          "ccCvv": {
            "required": "CVV é obrigatório",
            "invalidSize": "Seu código de segurança deve ter {{size}} dígitos"
          }
        }
      }
    },
    "paymentMethod": {
      "title": "Forma de pagamento",
      "paymentRefundBtnLabel": "Solicitar reembolso",
      "disabledPaymentRefundTooltip": "Reembolso já solicitado",
      "creditCard": "Cartão de crédito",
      "bankSlip": "Boleto bancário",
      "pix": "PIX",
      "multicard": "2 cartões de crédito",
      "cta": "Alterar cartão",
      "ctaBankSlip": "Imprimir boleto",
      "ctaPixCode": "Copiar código PIX",
      "processingRefund": "Processando reembolso...",
      "free": "Gratuito"
    },
    "refundError": {
      "title": "Não foi possível solicitar o reembolso!",
      "description": "Não conseguimos processar seu pedido de reembolso no momento. Envie um e-mail para o \nsuporte da {{brand}} no endereço ",
      "descriptionPart2": ", e nossa equipe vai te ajudar a concluir seu reembolso \no mais rápido possível.",
      "openTicket": "abra um chamado",
      "tryAgain": "Tentar novamente mais tarde",
      "openTicketButton": "Abrir um chamado",
      "supportText": "para o suporte da {{brand}}.",
      "closeButton": "Fechar janela"
    },
    "refundGenericError": {
      "title": "Não foi possível solicitar o reembolso neste momento!",
      "descriptionPart1": "Tente novamente mais tarde ou envie um e-mail para o suporte da {{brand}} no endereço ",
      "descriptionPart2": " para o suporte \nda {{brand}}.",
      "openTicketButton": "Tentar novamente mais tarde",
      "closeButton": "Fechar janela"
    },
    "refundBankSlip": {
      "title": "Reembolso para boleto",
      "description": "Para solicitar o reembolso de um pagamento via boleto, envie um e-mail para ",
      "descriptionPart2": "com os seguintes \ndados bancários:",
      "bankSlipData": "Nome completo:\nCPF:\nInstituição bancária:\nAgência (com dígito, se houver):\nConta (com dígito, se houver):",
      "openTicketButton": "Abrir um chamado",
      "closeButton": "Fechar janela"
    },
    "refundSuccess": {
      "title": "Seu reembolso foi solicitado com sucesso.",
      "description": "Seu reembolso será realizado, entramos em contato por e-mail para informar mais detalhes de como receber.",
      "emailContact": "contato por e-mail",
      "closeButton": "Fechar Janela",
      "toast": {
        "title": "Solicitação de reembolso enviada!",
        "message": "Após a conclusão do processo, você vai receber um comprovante via e-mail."
      }
    },
    "refundContactProducer": {
      "title": "Solicitação reembolso",
      "description": "Para solicitar o estorno da sua compra, entre em contato diretamente com o vendedor",
      "otherDetails": "Em casos de dúvidas ou o produtor não responder, entre em contato com o suporte da {{brand}} pelo e-mail",
      "closeButton": "Fechar janela"
    },
    "payments": {
      "title": "Pagamentos",
      "paymentDate": "Vencimento",
      "amount": "Valor",
      "status": "Status",
      "bankSlip": "Imprimir boleto",
      "pixCode": "Código pix",
      "reactivate": {
        "label": {
          "pix": "Gerar novo pix",
          "bankSlip": "Gerar novo boleto"
        },
        "success": {
          "pix": "Um novo código pix foi gerado. Copie o código e faça o pagamento.",
          "bankSlip": "Um novo boleto foi gerado. Imprima e faça o pagamento."
        },
        "error": {
          "pix": "Não foi possível gerar um novo pix. Tente novamente.",
          "bankSlip": "Não foi possível gerar um novo boleto. Tente novamente."
        }
      }
    },
    "status": {
      "payment": {
        "initiated": "Processando",
        "error": "Erro",
        "paid": "Aprovado",
        "free": "Gratuito",
        "refused": "Recusado",
        "cancelled": "Cancelado",
        "waitingPayment": "Aguardando pagamento",
        "scheduled": "Agendado",
        "overdue": "Expirado",
        "refundAnalyzing": "Em contestação",
        "chargeback": "Chargeback",
        "refunded": "Estornado"
      },
      "subscription": {
        "initiated": "Iniciada",
        "active": "Ativa",
        "pastDue": "Atrasada",
        "cancelled": "Cancelada",
        "ended": "Finalizada",
        "inactive": "Inativa"
      }
    },
    "itemRefunded": "Estornado",
    "itemRefundProcessing": "Estorno em análise",
    "orderBumpBadge": "Order bump"
  },
  "components": {
    "AuthEmailModal": {
      "title": "Para continuar, informe seu e-mail",
      "description": "Você receberá um link de autenticação da {{brand}} e, através dele, será redirecionado para executar essa ação",
      "label": "Seu e-mail",
      "placeholder": "E-mail utilizado na compra do produto",
      "action": "Enviar",
      "toast": {
        "title": "Verifique sua caixa de entrada!",
        "message": "Caso o e-mail fornecido esteja atrelado à essa compra, você receberá um link de autenticação. Aconselhamos olhar também em sua caixa de Spam."
      }
    },
    "EmptyStateComponent": {
      "cta": "Voltar para página anterior"
    },
    "VideoPlayer": {
      "skip10s": "Avançar 10 segundos",
      "playPause": "Pausar/Reproduzir",
      "back10s": "Voltar 10 segundos",
      "mute": "Mute/Unmute",
      "openQualityMenu": "Abrir menu de qualidade",
      "pictureInPicture": "Ativar/Desativar Picture in Picture",
      "fullscreen": "Entrar em tela cheia",
      "error": {
        "qualityChange": "Erro ao alterar qualidade do vídeo: {{error}}",
        "pictureInPicture": "Erro ao iniciar Picture in Picture: {{error}}",
        "videoThumbnail": "Erro ao gerar thumbnail do vídeo: {{error}}",
        "playback": {
          "title": "Processando Conteúdo",
          "message": "Este conteúdo está sendo processado pelo sistema, e em breve estará disponível para consumo."
        }
      }
    },
    "Profile": {
      "title": "Meu perfil",
      "empty": "Não foi possível carregar seu perfil.",
      "emptyTitle": "Perfil indisponível",
      "actions": {
        "save": "Salvar alterações"
      },
      "toast": {
        "successTitle": "Tudo certo!",
        "successMessage": "Suas informações foram atualizadas.",
        "errorTitle": "Ops!"
      },
      "errors": {
        "required": "Campo obrigatório",
        "invalidEmail": "E-mail inválido",
        "passwordMin": "A senha deve ter no mínimo 6 caracteres",
        "passwordMismatch": "As senhas não conferem",
        "invalidCpf": "CPF inválido",
        "invalidRg": "RG inválido"
      },
      "avatar": {
        "title": "Foto de perfil",
        "change": "Alterar foto",
        "successMessage": "Sua foto de perfil foi atualizada.",
        "errorMessage": "Não foi possível atualizar sua foto. Tente novamente.",
        "updateAppMessage": "Atualize o aplicativo pela loja para alterar sua foto de perfil."
      },
      "personalData": {
        "title": "Dados pessoais",
        "firstName": "Nome",
        "lastName": "Sobrenome",
        "email": "E-mail",
        "phone": "Telefone",
        "cpf": "CPF",
        "rg": "RG"
      },
      "address": {
        "street": "Endereço",
        "number": "Número",
        "complement": "Complemento",
        "district": "Bairro",
        "city": "Cidade",
        "state": "Estado",
        "zipCode": "CEP"
      },
      "password": {
        "title": "Alterar senha",
        "password": "Nova senha",
        "confirmation": "Confirmar nova senha",
        "successMessage": "Sua senha foi alterada."
      },
      "settings": {
        "title": "Configurações",
        "language": "Idioma"
      },
      "customFields": {
        "title": "Informações adicionais"
      }
    }
  },
  "toast": {
    "genericRequestError": {
      "title": "Não foi possível carregar algumas informações!",
      "message": "Recarregue a página ou tente novamente mais tarde."
    },
    "unauthorizedContent": {
      "title": "Você não tem acesso a este conteúdo",
      "message": "Ele não faz parte da sua matrícula. Volte para a página inicial e entre pelos seus cursos."
    },
    "apolloErrors": {
      "course": {
        "title": "Erro ao carregar as informações do curso!"
      },
      "courseContents": {
        "title": "Erro ao carregar o conteúdo do curso!"
      },
      "courseModules": {
        "title": "Erro ao carregar o conteúdo dos módulos do curso!"
      },
      "extraContents": {
        "title": "Erro ao carregar o material complementar do curso!"
      },
      "enrollmentIdsInfo": {
        "title": "Erro ao carregar as informações da matrícula!"
      },
      "lessonExtraContents": {
        "title": "Erro ao carregar o material adicional de uma aula!"
      },
      "orderDetails": {
        "title": "Erro ao carregar os detalhes do pedido!",
        "message": "Recarregue a página ou tente novamente mais tarde."
      },
      "productsCustomList": {
        "title": "Erro ao carregar mais produtos!"
      },
      "productUrl": {
        "title": "Erro ao carregar o link de venda do produto!"
      },
      "user": {
        "title": "Erro ao carregar as informações do usuário!"
      },
      "membersConfig": {
        "title": "Erro ao carregar as informações da área de membros!"
      }
    }
  },
  "Home": {
    "DefaultSectionTitle": {
      "seeAll": "Ver tudo"
    },
    "continue": {
      "continueSectionTitle": {
        "title": "Continue"
      },
      "toast": {
        "error": {
          "title": "Houve um erro ao carregar a seção de continue!",
          "message": "Recarregue a página ou tente novamente mais tarde."
        }
      }
    },
    "myProducts": {
      "myProductsSectionTitle": {
        "title": "Meus Produtos",
        "seeAll": "Ver tudo"
      },
      "emptyStateComponent": {
        "title": "Aguardando a liberação do produto",
        "description": "Se você já efetuou o pagamento, por favor, atualize a página dentro de alguns minutos. \n Em caso de boletos aguarde o tempo minimo para confirmação do pagamento."
      },
      "productCard": {
        "of": "de",
        "contents": "conteúdos",
        "status": {
          "finished": "Concluído",
          "blocked": "Bloqueado",
          "access": "Acessar",
          "continue": "Continuar"
        },
        "badges": {
          "live_meet": "Ao vivo",
          "buy": "Comprar agora",
          "locked": "Bloqueado"
        }
      },
      "toast": {
        "error": {
          "title": "Houve um erro ao carregar a seção de meus produtos!",
          "message": "Recarregue a página ou tente novamente mais tarde."
        }
      }
    }
  },
  "CourseDetails": {
    "emptyState": {
      "title": "Ainda não há conteúdos disponíveis",
      "description": "Por favor, volte mais tarde ou entre em contato \n com o(a) produtor(a) para saber quando os conteúdos serão disponibilizadas"
    },
    "product_type": {
      "path": "Combo",
      "online_course": "Curso Online",
      "ebook": "Ebook",
      "file": "Arquivo",
      "Quiz": "Prova",
      "webinar": "Webinar",
      "live_meet": "Encontro ao vivo",
      "mentoring": "Mentoria"
    },
    "product_niche": {
      "other": "Outros",
      "animals-and-plants": "Animais e Plantas",
      "apps-and-software": "Apps e Software",
      "business-and-career": "Negócios e Carreira",
      "cooking-and-gastronomy": "Culinária e Gastronomia",
      "design": "Design",
      "ecology-and-environment": "Ecologia e Meio Ambiente",
      "education": "Educação",
      "entretainment": "Entrentenimento",
      "fashion-and-beauty": "Moda e Beleza",
      "finances-and-investments": "Finanças e Investimentos",
      "health-and-sports": "Saúde e Esportes",
      "hobbies": "Hobbies",
      "home-and-construction": "Casa e Construção",
      "information-technology": "Tecnologia da Informação",
      "internet": "Internet",
      "languages": "Idiomas",
      "law": "Direito",
      "music-and-arts": "Música e Artes",
      "personal-development": "Desenvolvimento Pessoal",
      "public-tender": "Concurso Público",
      "relationships": "Relacionamentos",
      "sexuality": "Sexualidade",
      "spirituality-and-religion": "Espiritualidade e Religião"
    },
    "productCard": {
      "badges": {
        "buy": "Comprar agora",
        "locked": "Bloqueado"
      }
    },
    "download": {
      "label": "Download",
      "loading": "Baixando..."
    }
  },
  "clipboard": {
    "success": "Copiado para área de transferência",
    "failure": "Erro ao copiar para área de transferência"
  },
  "ExtraContent": {
    "extraContentTitle": "Geral do produto:",
    "lessonsExtraContentTitle": "Específico do conteúdo:",
    "ExtraContentCard": {
      "tooltip": "Não é possível baixar materiais tipo vídeo ou texto",
      "download": "Baixar Material",
      "downloading": "Baixando material..."
    },
    "NotSupported": {
      "title": "Este material não pode\nser visualizado, mas você pode\nbaixá-lo para acessá-lo.",
      "download": "Baixar Material"
    }
  },
  "ContentReport": {
    "button": "Denunciar",
    "menuOption": "Denunciar conteúdo",
    "modal": {
      "title": "Denunciar conteúdo",
      "description": "Selecione o motivo da denúncia.",
      "submit": "Enviar denúncia",
      "close": "Fechar",
      "successTitle": "Denúncia recebida",
      "successDescription": "Agradecemos a sua colaboração! A equipe HeroSpark irá analisar o conteúdo para manter este ambiente seguro e seguirá com as devidas orientações ou penalidades, conforme preveem nossos termos de uso.",
      "alreadyReportedTitle": "Conteúdo já denunciado",
      "alreadyReportedDescription": "Nós já recebemos a sua denúncia para este conteúdo. A equipe HeroSpark está analisando o material para manter este ambiente seguro e seguirá com as devidas orientações ou penalidades, conforme preveem nossos termos de uso.",
      "errorTitle": "Erro ao enviar denúncia",
      "errorDescription": "Não foi possível enviar sua denúncia neste momento. Tente novamente mais tarde."
    },
    "reasons": {
      "INAPPROPRIATE_FOR_MINORS": "Conteúdo inadequado para menores",
      "PREDATORY_PRACTICES": "Práticas predatórias ou enganosas",
      "HARASSMENT_OR_MISCONDUCT": "Assédio ou conduta imprópria do produtor",
      "COPYRIGHT_VIOLATION": "Violação de direitos autorais / plágio"
    },
    "reasonsDescription": {
      "INAPPROPRIATE_FOR_MINORS": "Pornografia, violência excessiva, apologia a crimes ou substâncias ilícitas.",
      "PREDATORY_PRACTICES": "Promessas de ganho de dinheiro fácil voltadas a atrair jovens, esquemas de pirâmide ou \"jogos de azar\" disfarçados de curso.",
      "HARASSMENT_OR_MISCONDUCT": "Produtor utiliza o espaço de aula ou suporte para abordagens pessoais inadequadas.",
      "COPYRIGHT_VIOLATION": "Uso não autorizado de propriedade intelectual ou cópia direta de outros autores."
    }
  },
  "InvitationAccept": {
    "title": "está feliz em te receber!",
    "subtitle": "Para iniciar, você precisa criar uma senha de acesso à plataforma",
    "password": {
      "label": "Senha",
      "placeholder": "Crie sua senha",
      "error-too-short": "A senha deve ter no mínimo 6 caracteres"
    },
    "passwordConfirmation": {
      "label": "Confirmar senha",
      "placeholder": "Repita a senha",
      "error-mismatch": "As senhas não coincidem"
    },
    "button": {
      "submit": "Salvar e continuar"
    },
    "invalid": {
      "title": "Convite inválido ou expirado",
      "description": "O link que você acessou não é mais válido. Solicite um novo convite ao produtor ou faça login se já tiver uma conta.",
      "cta": "Ir para o login"
    },
    "toast": {
      "error": {
        "title": "Ops!",
        "message": "Não foi possível concluir. Tente novamente."
      }
    }
  },
  "ProductPage": {
    "price": {
      "prefix": "Por apenas:",
      "installment-line": "ou em {{installments}}x de {{amount}}",
      "period": {
        "unitary": "",
        "monthly": "por mês",
        "quarterly": "por trimestre",
        "semesterly": "por semestre",
        "yearly": "por ano"
      },
      "installment-line-subscription": "ou parcelado em até {{installments}}x de {{amount}}"
    },
    "cta": {
      "free": "Acessar conteúdo gratuito",
      "subscription": "Quero assinar agora",
      "ebook": "Começar a ler agora",
      "default": "Quero comprar agora"
    },
    "ctaSecondary": {
      "free": "Acessar conteúdo gratuito",
      "subscription": "Quero assinar",
      "ebook": "Ler agora",
      "default": "Comprar agora"
    },
    "security": "Pagamento 100% seguro.",
    "digital": "100% digital",
    "availability": {
      "indeterminate": "Acesso ilimitado após a compra",
      "time": "Disponível por {{days}} dias após a compra",
      "date": "Disponível até {{date}}",
      "live-meet-quantity": "{{quantity}} encontros"
    },
    "features": {
      "indeterminate": "Acesso ao conteúdo quando quiser",
      "indeterminate-live-meet": "Interaja ao vivo com todos da sala",
      "app": "Disponível também pelo aplicativo",
      "certification": "Certificado ao final do curso",
      "accessibility": "Plataforma acessível para todos"
    },
    "about": {
      "title": "Sobre o Produto"
    },
    "content": {
      "title": "Conteúdo"
    },
    "curriculum": {
      "load-more": "Carregar mais módulos",
      "load-more-error": "Não foi possível carregar mais módulos. Tente de novo."
    },
    "combo": {
      "title": "Conteúdos do Combo",
      "about-title": "Sobre o Combo",
      "content-title": "Conteúdos do Combo",
      "details": "Saiba mais"
    },
    "teacher": {
      "title": "Sobre o instrutor"
    },
    "copyright": "Feito por Herospark",
    "notFound": {
      "title": "Produto não encontrado",
      "description": "O produto que você procura não existe ou não está mais disponível."
    },
    "coursePreview": {
      "go-back": "Voltar para página de vendas"
    },
    "courseType": {
      "online_course": "Curso online",
      "ebook": "Ebook",
      "live_meet": "Encontro ao vivo",
      "live_meeting": "Ao vivo",
      "webinar": "Webinar",
      "file": "Arquivo",
      "package": "Combo"
    }
  },
  "PasswordStrength": {
    "weak": "Senha fraca",
    "medium": "Senha média",
    "good": "Senha boa",
    "strong": "Senha forte"
  },
  "PasswordRequest": {
    "title": "Esqueceu sua senha?",
    "subtitle": "Informe seu e-mail e enviaremos um link para redefinir sua senha",
    "email": {
      "label": "E-mail",
      "placeholder": "Digite seu e-mail"
    },
    "button": {
      "submit": "Enviar link",
      "back-to-login": "Voltar para o login"
    },
    "sent": {
      "title": "Verifique seu e-mail",
      "description": "Caso o e-mail informado tenha uma conta, enviaremos o link de redefinição de senha.",
      "cta": "Voltar para o login"
    },
    "toast": {
      "error": {
        "title": "Ops!",
        "message": "Não foi possível concluir. Tente novamente."
      }
    }
  },
  "PasswordReset": {
    "title": "Crie uma nova senha",
    "subtitle": "Digite a nova senha de acesso à plataforma",
    "password": {
      "label": "Nova senha",
      "placeholder": "Crie sua nova senha",
      "error-too-short": "A senha deve ter no mínimo 6 caracteres"
    },
    "passwordConfirmation": {
      "label": "Confirmar senha",
      "placeholder": "Repita a senha",
      "error-mismatch": "As senhas não coincidem"
    },
    "button": {
      "submit": "Redefinir senha"
    },
    "invalid_token": {
      "title": "Link inválido",
      "description": "Essa senha já foi redefinida ou o link não é válido. Solicite um novo link para continuar."
    },
    "expired_token": {
      "title": "Link expirado",
      "description": "O link para redefinição de senha expirou. Solicite um novo link para continuar."
    },
    "invalid": {
      "request-new": "Solicitar novo link",
      "back-to-login": "Voltar para o login"
    },
    "toast": {
      "error": {
        "title": "Ops!",
        "message": "Não foi possível concluir. Tente novamente."
      }
    }
  },
  "Login": {
    "email": {
      "label": "E-mail",
      "placeholder": "Digite seu e-mail",
      "error": "Ops! Este app é exclusivo para alunos. Se você é um produtor e quer gerenciar seu negócio, acesse sua conta pelo navegador em: app.herospark.com"
    },
    "school": {
      "label": "Selecionar escola",
      "description": "Escolha qual escola você gostaria de acessar agora",
      "placeholder": "Selecione sua escola"
    },
    "password": {
      "label": "Senha",
      "placeholder": "Digite sua senha",
      "forgot-password": "Esqueceu sua senha?",
      "error": "senha inválida"
    },
    "button": {
      "continue": "Continuar",
      "login": "Entrar"
    }
  },
  "Comments": {
    "title": "Comentários",
    "titleEmpty": "Nenhum comentário",
    "titleCount_one": "{{count}} comentário",
    "titleCount_other": "{{count}} comentários",
    "emptyState": {
      "title": "Seja o primeiro a comentar",
      "description": "Tire suas dúvidas ou compartilhe aprendizados com a turma.",
      "cta": "Comentar"
    },
    "loadError": "Não foi possível carregar os comentários.",
    "retry": "Tentar novamente",
    "loadMore": "Carregar mais",
    "topic": {
      "answered": "Respondido",
      "reply": "Responder",
      "repliesCount_one": "{{count}} resposta",
      "repliesCount_other": "{{count}} respostas",
      "noReplies": "Sem respostas",
      "viewReplies": "Ver respostas",
      "hideReplies": "Ocultar respostas"
    },
    "newTopic": {
      "cta": "Comentar",
      "modalTitle": "Novo comentário",
      "placeholder": "Seu comentário",
      "titlePlaceholder": "Assunto",
      "descriptionPlaceholder": "Descreva sua dúvida ou contribuição",
      "submit": "Publicar",
      "cancel": "Cancelar",
      "success": "Comentário publicado com sucesso.",
      "error": "Não foi possível publicar o comentário. Tente novamente.",
      "offline": "Você está offline. Conecte-se para publicar.",
      "validations": {
        "titleRequired": "Escreva o assunto antes de enviar.",
        "descriptionRequired": "Escreva a descrição antes de enviar."
      }
    },
    "newPost": {
      "placeholder": "Escreva uma resposta",
      "submit": "Responder",
      "success": "Resposta enviada.",
      "error": "Não foi possível enviar sua resposta. Tente novamente.",
      "offline": "Você está offline. Conecte-se para responder.",
      "validations": {
        "bodyRequired": "A resposta não pode estar vazia."
      }
    },
    "anonymous": "Aluno"
  },
  "Messages": {
    "title": "Mensagens",
    "newMessage": "Nova mensagem",
    "loadError": "Não foi possível carregar as mensagens.",
    "retry": "Tentar novamente",
    "loadMore": "Carregar mais",
    "backToList": "Voltar para lista de mensagens",
    "emptyState": {
      "title": "Nenhuma mensagem encontrada",
      "description": "As mensagens que você enviar para os produtores de conteúdo aparecerão aqui."
    },
    "reply": {
      "placeholder": "Responder mensagem...",
      "submit": "Responder para todos",
      "success": "Sua resposta foi enviada.",
      "error": "Não foi possível enviar sua resposta. Tente novamente.",
      "offline": "Você está offline. Conecte-se para responder.",
      "validations": {
        "textRequired": "A resposta não pode estar vazia."
      }
    },
    "new": {
      "title": "Nova mensagem",
      "subjectLabel": "Assunto:",
      "subjectPlaceholder": "Assunto da mensagem",
      "placeholder": "Escreva sua mensagem...",
      "submit": "Enviar mensagem",
      "success": "Sua mensagem foi enviada.",
      "error": "Não foi possível enviar sua mensagem. Tente novamente.",
      "offline": "Você está offline. Conecte-se para enviar.",
      "validations": {
        "subjectRequired": "Escreva o assunto antes de enviar.",
        "textRequired": "Escreva a mensagem antes de enviar."
      }
    }
  },
  "AdminPreview": {
    "banner": {
      "text": "Você está visualizando a área do aluno"
    }
  },
  "PremioReclameAqui": {
    "title": "Curtiu estudar por aqui?",
    "description": "A HeroSpark é a plataforma onde as suas aulas ficam. Ela está concorrendo no Prêmio RA 2026 em {{category}}, e um voto seu ajudaria demais.",
    "cta": "Clique para votar na HeroSpark",
    "ctaShort": "Quero ajudar",
    "dismiss": "Voltar para aula",
    "accessibility": {
      "awardLogo": "Prêmio Reclame AQUI 2026",
      "ctaHint": "Abre a página de votação do Prêmio Reclame AQUI"
    }
  },
  "ErrorBoundary": {
    "title": "Algo deu errado",
    "description": "Não conseguimos carregar esta página. Tente de novo em instantes — já avisamos nosso time.",
    "retry": "Tentar novamente"
  },
  "FeaturedProductHome": {
    "progressStrip": {
      "summary": "{{completed}} de {{total}} conteúdos · {{progress}}%",
      "accessibilityLabel": "Progresso no curso {{name}}: {{completed}} de {{total}} conteúdos concluídos"
    },
    "modules": {
      "defaultTitle": "Módulos",
      "cardAccessibilityLabel": "Abrir o módulo {{name}}"
    },
    "extraContents": {
      "defaultTitle": "Materiais de apoio"
    }
  },
  "DirectPurchase": {
    "title": "Seu próximo aprendizado está aqui!",
    "panelTitle": {
      "home_section": "Comprar agora",
      "next_learning": "Seu próximo aprendizado está aqui!"
    },
    "buyNow": "Comprar agora",
    "loading": "Carregando a oferta...",
    "loadError": "Não foi possível carregar a oferta agora. Você pode concluir a compra no checkout.",
    "cashPrice": "ou {{amount}} à vista",
    "installments": "Parcelamento",
    "installmentOption": "{{count}}x de {{amount}}",
    "useCard": "Usar meu cartão {{brand}} •••• {{lastDigits}}",
    "consentLabel": "Autorizo a cobrança",
    "consent": "Ao clicar em comprar, autorizo a cobrança de {{amount}} no cartão final {{lastDigits}}.",
    "buyOneClick": "Comprar com 1 clique",
    "changeMethod": "Trocar método de pagamento",
    "generatePix": "Gerar Pix de {{amount}}",
    "pixInstructions": "Abra o app do seu banco e pague com o QR Code ou com o Pix copia e cola.",
    "copyPix": "Copiar código Pix",
    "waitingPix": "Aguardando o pagamento. Esta tela atualiza sozinha.",
    "pixValidUntil": "Este Pix vale até {{date}}.",
    "pixExpiresIn": "Este Pix vence em {{time}}.",
    "pixExpired": "Este Pix venceu antes do pagamento. Gere um novo para concluir a compra.",
    "pixExpiredShort": "Este Pix venceu.",
    "newPix": "Gerar novo Pix",
    "processing": "Processando seu pagamento...",
    "pending": "Seu pagamento está em análise. Você recebe um e-mail assim que ele for aprovado.",
    "pendingPix": "Seu Pix está sendo gerado. Você recebe o QR Code por e-mail e o acesso é liberado assim que o pagamento cair.",
    "failed": "Pagamento não aprovado.",
    "failedHint": "Não conseguimos aprovar a compra por aqui. Tente de novo ou troque o método de pagamento.",
    "tryAgain": "Tentar de novo",
    "goToCheckout": "Ir para o checkout",
    "checkoutReason": {
      "missing_document": "Para comprar por aqui, precisamos do seu CPF no cadastro. Você pode concluir a compra no checkout.",
      "unsupported_offer": "Esta oferta é concluída no checkout."
    },
    "toast": {
      "title": "Compra confirmada!",
      "unlocked": "Seu produto já está liberado.",
      "unlocking": "Seu acesso aparece aqui em instantes."
    }
  },
  "Push": {
    "prompt": {
      "title": "Ative as notificações",
      "description": "Avisamos só o que importa para os seus estudos. Você controla o que recebe.",
      "benefits": {
        "access": "Quando o seu acesso a um curso for liberado",
        "content": "Quando sair conteúdo novo nos seus cursos",
        "payments": "Quando um pagamento estiver perto de vencer"
      },
      "allow": "Permitir",
      "dismiss": "Agora não",
      "footnote": "Você pode mudar isso depois em Perfil > Notificações."
    },
    "deepLink": {
      "unavailableTitle": "Conteúdo indisponível",
      "unavailableMessage": "O que essa notificação mostrava não está mais disponível."
    },
    "preferences": {
      "title": "Notificações",
      "categories": {
        "transactional": {
          "label": "Avisos importantes",
          "description": "Acesso liberado, pagamentos e segurança da conta. Ficam sempre ligados."
        },
        "engagement": {
          "label": "Conteúdo e lembretes",
          "description": "Conteúdo novo nos seus cursos e lembretes de estudo."
        },
        "news": {
          "label": "Novidades da HeroSpark",
          "description": "Novidades e recursos da plataforma."
        }
      },
      "loadError": "Não foi possível carregar suas preferências de notificação.",
      "errorTitle": "Não foi possível salvar",
      "errorMessage": "Tente de novo em instantes.",
      "device": {
        "deniedTitle": "Notificações desativadas neste aparelho",
        "deniedDescription": "Para receber os avisos, ative as notificações do app nos ajustes do aparelho.",
        "openSettings": "Abrir ajustes",
        "undeterminedDescription": "Ative as notificações para receber estes avisos neste aparelho.",
        "enable": "Ativar notificações",
        "installApp": "Instale o app da HeroSpark para receber notificações",
        "stores": {
          "app-store": {
            "name": "App Store",
            "label": "Baixar o app da HeroSpark na App Store"
          },
          "google-play": {
            "name": "Google Play",
            "label": "Baixar o app da HeroSpark no Google Play"
          }
        }
      }
    }
  }
}
